const state = {
	corona: {
		de: "Nutzen Sie das Freitextfeld auch gerne, um sich zu den Veränderungen der Lehrveranstaltung im Rahmen der Corona Pandemie zu äußern.",
		en: "Feel free to also use the text field to comment on the changes in this course in the context of the Corona pandemic",
	},
	general: {
		de:
			"Bitte haben Sie Verständnis dafür, dass auch das Projekt Qualis von der Corona Pandemie überrascht wurde und in sehr kurzer Zeit ein Online-System entwickeln musste. Daher kann es vorkommen, dass einige Fragen enthalten sind, die bei einer Online-Veranstaltung nicht anwendbar sind.",
		en:
			"Please understand that the project Qualis has been surprised by the Corona pandemic as well and had to develop an online system in a short amout of time. Thus, it may happen that some questions appear that can't be applied to online courses",
	},
	label: {
		uni: {
			de: ["Voll&shy;kom&shy;men", "Eher", "Neutral", "Weniger", "Gar nicht"],
			en: ["completely", "rather", "neutral", "less", "not at all"],
		},
		bi: {
			de: ["Sehr<br />über&shy;for&shy;dernd", "Über&shy;for&shy;dernd", "Optimal", "Unter&shy;for&shy;dernd", "Sehr<br />unter&shy;for&shy;dernd"],
			en: ["too demanding", "demanding", "ideal", "little demanding", "too little demanding"],
		},
		mwp: {
			de: ["Sehr gut", "Gut", "Befriedigend", "Ausreichend", "Mangelhaft"],
			en: ["Very good", "Good", "Satisfying", "Sufficient", "Insufficient"],
		},
		dsp_head: {
			de: "Dozentenspezifische Evaluation",
			en: "Lecturer-specific evaluation",
		},
	},
	evaHead: {
		title: {
			de: "Lehrevaluation",
			en: "Course Evaluation",
		},
		courseInfo: {
			de: "Angaben zur Lehrveranstaltung",
			en: "Information regarding the course",
		},
		courseTitle: {
			de: "Veranstaltungstitel",
			en: "Title",
		},
		courseLecturer: {
			de: "Dozent/in",
			en: "Lecturer",
		},
		evaStart: {
			de: "Evaluation der Lehrveranstaltung",
			en: "Evaluation of the course",
		},
		personalData: {
			de: "Persönliche Angaben:",
			en: "Personal information:",
		},
	},
	sendButton: {
		de: "Absenden",
		en: "Send",
	},
	selectMsg: {
		de: "-- Bitte auswählen --",
		en: "-- Please select --",
	},
	age: {
		de: "Jahre",
		en: "years",
	},
};

const getters = {
	coronaMsg: state => state.corona,
	generalMsg: state => state.general,
	uniLabel: state => state.label.uni,
	biLabel: state => state.label.bi,
	mwpLabel: state => state.label.mwp,
	evaHead: state => state.evaHead,
	sendButton: state => state.sendButton,
	selectMsg: state => state.selectMsg,
	personalData: state => state.evaHead.personalData,
	age: state => state.age,
	dspHead: state => state.label.dsp_head,
};

const actions = {};

const mutations = {};

export default {
	state,
	getters,
	actions,
	mutations,
};
